import { defineStore } from 'pinia';
import { MarketClassify } from '@/api/market.js';

const withDisplayLabel = (list) =>
    list.map((item) => ({
        ...item,
        label: item.code === 'KSE' ? 'KRX' : item.code
    }));

export const useStockStore = defineStore('stock', {
    state: () => ({
        marketList: withDisplayLabel(uni.getStorageSync('marketList') || [])
    }),
    actions: {
        getMarketList() {
            return MarketClassify().then((res) => {
                this.marketList = withDisplayLabel(res.result);
                uni.setStorageSync('marketList', this.marketList);
            });
        }
    }
});
